/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``book-closed.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const BookClosedIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M13.5241 2.26795C13.3116 2.25058 13.0324 2.25 12.6 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06902C3.85372 3.18632 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V11.6513C4.19126 11.3961 4.70357 11.25 5.25 11.25H14.25V3.9C14.25 3.46759 14.2494 3.18838 14.2321 2.97588C14.2154 2.77213 14.1872 2.69659 14.1683 2.65951C14.0963 2.51839 13.9816 2.40365 13.8405 2.33175C13.8034 2.31285 13.7279 2.28459 13.5241 2.26795ZM15.75 3.87108C15.75 3.47572 15.75 3.13466 15.7271 2.85373C15.7028 2.55722 15.6494 2.26231 15.5048 1.97852C15.289 1.55516 14.9448 1.21095 14.5215 0.995237C14.2377 0.850641 13.9428 0.797154 13.6463 0.772928C13.3653 0.749976 13.0243 0.749987 12.6289 0.750001L6.56903 0.750001C5.9653 0.749991 5.46703 0.749984 5.06113 0.783147C4.63956 0.81759 4.25203 0.891514 3.88803 1.07698C3.32354 1.3646 2.8646 1.82354 2.57698 2.38803C2.39151 2.75203 2.31759 3.13956 2.28315 3.56113C2.24998 3.96703 2.24999 4.4653 2.25 5.06903V12.931C2.24999 13.3347 2.24999 13.6912 2.2599 14.0045C2.25334 14.0855 2.25 14.1673 2.25 14.25C2.25 14.3314 2.26296 14.4097 2.28691 14.4831C2.32291 14.8876 2.39801 15.2607 2.57698 15.612C2.8646 16.1765 3.32354 16.6354 3.88803 16.923C4.25203 17.1085 4.63956 17.1824 5.06113 17.2169C5.46702 17.25 5.96529 17.25 6.56901 17.25H12.6289C13.0243 17.25 13.3653 17.25 13.6463 17.2271C13.9428 17.2028 14.2377 17.1494 14.5215 17.0048C14.9448 16.7891 15.289 16.4448 15.5048 16.0215C15.6494 15.7377 15.7028 15.4428 15.7271 15.1463C15.7475 14.896 15.7497 14.5979 15.75 14.2562C15.75 14.2541 15.75 14.2521 15.75 14.25V14.1797C15.75 14.1629 15.75 14.1459 15.75 14.1289V3.87108ZM3.76259 14.0547C3.76647 14.1488 3.77154 14.2356 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H12.6C13.0324 15.75 13.3116 15.7494 13.5241 15.7321C13.7279 15.7154 13.8034 15.6872 13.8405 15.6683C13.9816 15.5963 14.0964 15.4816 14.1683 15.3405C14.1872 15.3034 14.2154 15.2279 14.2321 15.0241C14.2494 14.8116 14.25 14.5324 14.25 14.1V12.75H5.25C4.48775 12.75 3.85829 13.3186 3.76259 14.0547Z"
        transform=""
      />
    </g>
  </svg>
);

BookClosedIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

BookClosedIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

BookClosedIcon.displayName = "BookClosedIcon";

export default BookClosedIcon;
